/**
 * DriveZone — SkeletonCard
 * Animated loading placeholder shown while a search is in progress.
 * Three of these render in the ProximitySearch panel during loading.
 */
export default function SkeletonCard() {
  return (
    <div className="card p-4 space-y-3 animate-pulse">
      <div className="flex items-center justify-between">
        <div className="h-4 bg-slate-200 rounded w-2/5" />
        <div className="h-5 bg-slate-200 rounded w-14" />
      </div>
      <div className="flex gap-4">
        <div className="h-3 bg-slate-200 rounded w-24" />
        <div className="h-3 bg-slate-200 rounded w-20" />
      </div>
    </div>
  )
}
